import React, { useState } from 'react'
import { CustomPickerComponent } from './CustomPickerComponent'
import './ColorPickerWidget.scss'

const ColorPickerWidget = ({ color, onChange, presetColors, onClose, setChangedColor, changedColor }) => {
  const getColor = changedColor || color
  const [newColor, setNewColor] = useState({ ...getColor })

  const onColorCancel = () => {
    onClose()
    setChangedColor && setChangedColor(null)
  }

  const onColorChange = (color) => {
    setNewColor(color)
    setChangedColor && setChangedColor(color)
  }

  const onColorConfirm = () => {
    onChange({ ...newColor })
    onColorCancel()
  }

  return (
    <div className='viso-color-picker-widget'>
      <div className='viso-color-picker-widget__content'>
        <CustomPickerComponent
          color={newColor}
          onChange={onColorChange}
          presetColors={presetColors}
        />
      </div>
      <div className='viso-color-picker-widget__footer'>
        <button
          className='viso-color-picker-widget__action'
          onClick={onColorCancel}
        >
          Cancel
        </button>
        <button
          className='viso-color-picker-widget__action viso-color-picker-widget__action--confirm'
          onClick={onColorConfirm}
        >
          Select
        </button>
      </div>
    </div>
  )
}

export default ColorPickerWidget